import varAxios from "../../Comman/axios";
import { getPrivacyPolicyUrl, updatePrivacyPolicyUrl } from '../../Comman/apiEndPoints';

export const Fetch_Privacy_Policy_Request = "Fetch_Privacy_Policy_Request";
export const Update_Privacy_Policy_Success = "Update_Privacy_Policy_Success";


export function getPrivacyPolicyFunc() {
   return (dispatch) => {
      dispatch(fetchPrivacyPolicyRequest())
      return varAxios.get(getPrivacyPolicyUrl)
         .then(response => {
            dispatch(
               updatePrivacyPolicySuccess(response.data.statusCode, response.data.GlobalSettings, '')
            );
         })
         .catch((error) => {
            console.log("error", error);
         })
   }

}
export function fetchPrivacyPolicyRequest() {
   return {
      type: Fetch_Privacy_Policy_Request
   }
}
export function updatePrivacyPolicySuccess(statuscode, value, Message) {
   return {
      type: Update_Privacy_Policy_Success,
      statuscode,
      value,
      Message
   }
}

export function updatePrivacyPolicy(value) {
   let data = {
      SettingValue : value
   }
   return (dispatch) => {
      dispatch(fetchPrivacyPolicyRequest())
       return varAxios.post(updatePrivacyPolicyUrl, data,
           JSON.stringify({
               derived: 'd',
               message: 'e'
           }))
           .then((response) => {
               dispatch(
                  updatePrivacyPolicySuccess(response.data.statusCode, [], response.data.Message)
            );
           })
           .catch((error) => {
               console.log(error)
           })
   }
}